
import React,{useEffect} from "react";
import { Link, useParams} from "react-router-dom";
import useAuth from "../../Hooks/useAuth";
import DiscoverItem from "../common/DiscoverItem";
import LoadMore from "../common/LoadMore";
import ProfileCard from "../common/ProfileCard";

const ProfileDetails = () => {
  const {data,profileInfo,setProfileInfo,showDummyImage} = useAuth();
  const {id} = useParams();
  useEffect(()=>{
    const profile = data.find(info => parseInt(info?.id) === parseInt(id));
    setProfileInfo(profile)
  },[data,id,setProfileInfo])
  return (
    <section className="profile">
      <div className="profile-banner">
        <img src={require("../../assets/images/common/profile-banner.png")} alt={'profileBanner'} onError={({currentTarget},imageSize='1900X350')=>showDummyImage({currentTarget},imageSize)}/>
      </div>
      <div className="container">
        <div className="profile-details">
          <div className="profile-left">
            {
              profileInfo?.category && <ProfileCard data={profileInfo} />
            }
          </div>
          <div className="profile-right">
            <div className="profile-right-top">
              <div className="profile-right-top-info">
                <button className="active">
                  <span>On Sale</span>
                </button>
                <button>
                  <span>Sold Out</span>
                  <small>156</small>
                </button>
                <button>
                  <span>Following</span>
                  <small>156</small>
                </button>
                <button>
                  <span>Followers</span>
                  <small>156</small>
                </button>
                <button>
                  <span>Dashboard</span>
                </button>
              </div>
              <Link
                to={`/edit-profile/${id}`} className="profile-edit-btn">
                Edit Profile
              </Link>
            </div>
            <div className="profile-right-bottom">
              {data.map((ele) => {
                return <DiscoverItem data={ele} key={ele.id} />;
              })}
            </div>
            <LoadMore btnTitle="Load more Collections" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileDetails;
